<app-header-web *appNgIfWeb />
<app-header-tablet-and-mobile *appNgIfPhoneAndTablet>
  <ng-content select="[sidebar]" ngProjectAs="[sidebar]" />
</app-header-tablet-and-mobile>
